import { Fragment } from 'react';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { useGetIsUngatedForConditionalAssociations } from '../v2/hooks/useGetIsUngatedForConditionalAssociations';
import { getIsPropertyInput } from '../utils/getInputFieldType';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const renderDependents = (dependents, path) => {
  if (!dependents) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: dependents.map(dependent => {
      const isPropertyInput = getIsPropertyInput(dependent);
      const name = isPropertyInput ? dependent.property.name : dependent.fieldName;
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          "data-test-id": `${path}-${name}`,
          children: dependent.render()
        }), renderDependents(dependent.dependents, `${path}-${name}`)]
      }, `${path}-${name}`);
    })
  });
};
const PropertiesFormDependentSection = ({
  children,
  property,
  enableDependentAssociations = false
}) => {
  const isUngatedForConditionalAssociations = useGetIsUngatedForConditionalAssociations({
    enableDependentAssociations
  });
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": `${property.name}-dependents`,
    borderStyle: "solid",
    borderWidth: "100",
    borderColor: "border-core-subtle",
    borderInlineStartColor: "border-interactive-default",
    borderInlineStartWidth: "300",
    position: "relative",
    borderRadius: "100",
    marginBlockStart: "400",
    marginBlockEnd: "200",
    padding: "400",
    children: [/*#__PURE__*/_jsx(Small, {
      weight: "medium",
      children: /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "propertiesForm.dependentFieldsHelp",
          options: {
            label: property.label
          }
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isUngatedForConditionalAssociations ? 'propertiesForm.dependentLogicTitle' : 'propertiesForm.dependentFieldsTitle'
        })
      })
    }), children]
  });
};
export default PropertiesFormDependentSection;